/**
 * Mixed doubles (1) and levels doubles: men's (2) and women's (3).
 * Singles (4–5) and unbalanced types (6–9) are excluded from win percentages.
 */
export const MIXED_LEVELS_GAME_TYPE_IDS = [1, 2, 3];

/**
 * Wins ÷ games played, one decimal. Same rounding on club cards and the club
 * performance tile so a one-season club shows one number in both places.
 * @returns {number|null}
 */
export function winRatePctFromRecord(wins, played) {
  const w = Number(wins) || 0;
  const p = Number(played) || 0;
  if (p <= 0) return null;
  return Math.round((1000 * w) / p) / 10;
}
